import { Type } from "@sinclair/typebox";
import { FileAsset, TranslatedString } from "./common";
const Background = Type.Object({
    name: Type.Union([Type.Literal("gradient"), Type.Literal("color"), Type.Literal("image")]),
    textColor: Type.Optional(Type.String()),
    bgStart: Type.Optional(Type.String()),
    bgEnd: Type.Optional(Type.String()),
    bgColor: Type.Optional(Type.String()),
    bgImage: Type.Optional(Type.Object({
        file: Type.Optional(FileAsset),
        mode: Type.Optional(Type.Union([Type.Literal("repeat"), Type.Literal("cover")])),
    })),
});
export const MessengerThemeSettings = Type.Object({
    logo: Type.Optional(Type.Object({
        file: FileAsset,
    })),
    actionColour: Type.Optional(Type.String({ default: "#3A8DDE" })),
    background: Type.Optional(Background),
}, {
    title: "MessengerThemeSettings",
});
export const DisplaySettings = Type.Object({
    showAgentAvatars: Type.Optional(Type.Boolean({ default: false })),
    placement: Type.Optional(Type.Object({
        position: Type.Optional(Type.Union([Type.Literal("bottom-right"), Type.Literal("bottom-left")], {
            default: "bottom-right",
        })),
        offsetBottom: Type.Optional(Type.Number({ default: 20 })),
        offsetSide: Type.Optional(Type.Number({ default: 20 })),
    }, { default: {} })),
    hidePoweredBy: Type.Optional(Type.Boolean({ default: false })),
}, {
    title: "DisplaySettings",
});
export const GeneralSettings = Type.Object({
    defaultLanguage: Type.Optional(Type.Object({ id: Type.String(), locale: Type.String(), is_rtl: Type.Boolean() })),
    availableLanguages: Type.Optional(Type.Array(Type.Object({ id: Type.String(), locale: Type.String(), is_rtl: Type.Boolean() }))),
}, {
    title: "GeneralSettings",
});
const ApnObject = Type.Object({
    p8: Type.String({ minLength: 1 }),
    keyId: Type.String({ minLength: 1 }),
    bundleId: Type.String({ minLength: 1 }),
    teamId: Type.String({ minLength: 1 }),
});
const FcmObject = Type.Object({
    projectId: Type.String({ minLength: 1 }),
    appId: Type.String({ minLength: 1 }),
    serviceCredentials: Type.String({ minLength: 1 }),
});
const WebDeploymentSettings = Type.Object({
    type: Type.Literal("web"),
    addMessengerToHelpCenter: Type.Optional(Type.Boolean()),
    addMessengerToWebsite: Type.Optional(Type.Boolean()),
    specifyTrustedDomains: Type.Optional(Type.Boolean()),
    trustedDomains: Type.Optional(Type.String()),
    enablePushNotifications: Type.Optional(Type.Boolean({ default: false })),
    requireJwtAuthentication: Type.Optional(Type.Boolean({ default: false })),
    pushNotificationService: Type.Optional(Type.Union([Type.Literal("webpush"), Type.Literal("fcm")])),
    pushNotification: Type.Optional(Type.Object({
        fcm: Type.Optional(FcmObject),
    })),
}, {
    title: "WebDeploymentSettings",
});
const IosDeploymentSettings = Type.Object({
    type: Type.Literal("ios"),
    appId: Type.Optional(Type.String()),
    enablePushNotifications: Type.Optional(Type.Boolean({ default: false })),
    requireJwtAuthentication: Type.Optional(Type.Boolean({ default: false })),
    pushNotificationService: Type.Optional(Type.Union([Type.Literal("apns"), Type.Literal("fcm")])),
    pushNotification: Type.Optional(Type.Object({
        apn: Type.Optional(ApnObject),
        fcm: Type.Optional(FcmObject),
    })),
}, {
    title: "IosDeploymentSettings",
});
const AndroidDeploymentSettings = Type.Object({
    type: Type.Literal("android"),
    appId: Type.Optional(Type.String()),
    enablePushNotifications: Type.Optional(Type.Boolean({ default: false })),
    requireJwtAuthentication: Type.Optional(Type.Boolean({ default: false })),
    pushNotificationService: Type.Optional(Type.Literal("fcm")),
    pushNotification: Type.Optional(Type.Object({
        fcm: Type.Optional(FcmObject),
    })),
}, {
    title: "AndroidDeploymentSettings",
});
export const DeploymentSettingsSchema = Type.Optional(Type.Union([WebDeploymentSettings, IosDeploymentSettings, AndroidDeploymentSettings]));
export const LauncherSettings = Type.Object({
    type: Type.Optional(Type.Union([Type.Literal("button"), Type.Literal("proactive")], { default: "button" })),
    icon: Type.Optional(Type.Object({
        type: Type.Union([Type.Literal("icon"), Type.Literal("file")]),
        icon: Type.Optional(Type.String()),
        file: Type.Optional(FileAsset),
    })),
    color: Type.Optional(Type.String({ default: "#3A8DDE" })),
    delayShowingMessage: Type.Optional(Type.Number({ default: 0 })),
    nameDisplayed: Type.Optional(TranslatedString),
    message: Type.Optional(TranslatedString),
    offlineMessage: Type.Optional(TranslatedString),
    disableChatOutsideWorkingHours: Type.Optional(Type.Boolean({ default: false })),
}, {
    title: "LauncherSettings",
});
export const MessengerSettings = Type.Object({
    displaySettings: DisplaySettings,
    themeSettings: MessengerThemeSettings,
    generalSettings: GeneralSettings,
    deploymentSettings: DeploymentSettingsSchema,
    launcherSettings: LauncherSettings,
}, { title: "MessengerSettings" });
